import { ReactElement } from "react";
import { roleMap } from "../config/roleMapping";
import authService from "../services/auth-service";

const ComponentRequireRole = ({ requiredRoles, children }: { requiredRoles: Array<string>; children: React.ReactElement }) => {
   const { getUserInfo } = authService;

   // Senior pastor has global access
   requiredRoles.push(roleMap.seniorPastor);

   const userRole = getUserInfo()?.role?.id;
   const userHasRequiredRole = requiredRoles?.includes(userRole);

   return userHasRequiredRole ? children : null;
};

type RequirementGuardType = { condition: boolean; children: ReactElement };
const RequirementGuard = ({ condition, children }: RequirementGuardType) => {
   return condition ? children : null;
};

export { ComponentRequireRole, RequirementGuard };
